import { ajax } from '../../../services/helper'
class ApiService {

    getEntityTypesData = (type) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/entityTypes/list?type="+type
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    addEntityType = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/entityTypes/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    getEntityTypeById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/entityTypes/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     editEntityType = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/entityTypes/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     getcostCenterDetailList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/costCenters/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }    

    getEmployeesListData = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }    

    
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Entity Types/services/apiservices.js